<template>
  <div>
    <MyGridLayout :layout-data="layoutData" v-if="isGridShow"/>
    <div id="marker_table" style="padding:20px 0 20px 0;">
      <h3>marker_celltype</h3>
      <el-table
          style="overflow-y: auto; height: 400px"
          fit
          :header-cell-style="{color: 'black'}"
          :data="this.table_marker_celltype.tableData.slice(
              (this.table_marker_celltype.currentPage-1)*this.table_marker_celltype.pageSize,
              this.table_marker_celltype.currentPage*this.table_marker_celltype.pageSize)"
          :row-style="{height: '30px'}"
          stripe
          :cell-style="{padding: '0', color: 'black', margin: '0'}">
        <el-table-column prop="gene" label="gene" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.gene"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getGenes">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.gene"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.gene) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="p_val" label="p_val" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.p_val"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getDataset">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.p_val"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.p_val) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="avg_log2FC" label="avg_log2FC" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.avg_log2FC"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getSample">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.avg_log2FC"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.avg_log2FC) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="pct.1" label="pct.1" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.pct_1"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getTechnology">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.pct_1"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.pct_1) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="pct.2" label="pct.2" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.pct_2"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getOrgan">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.pct_2"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.pct_2) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="p_val_adj" label="p_val_adj" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.p_val_adj"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getTissue">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.p_val_adj"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.p_val_adj) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="cluster" label="cluster" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.cluster"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getSpots">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.cluster"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.cluster) }}</div>-->
          <!--          </template>-->
        </el-table-column>
      </el-table>
      <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="this.table_marker_celltype.currentPage"
                     :page-sizes="[10,20,50,100]"
                     :page-size="this.table_marker_celltype.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="this.table_marker_celltype.tableData.length">
      </el-pagination>

      <h3>marker_domain</h3>
      <el-table
          style="overflow-y: auto; height: 400px"
          fit
          :header-cell-style="{color: 'black'}"
          :data="this.table_marker_domain.tableData.slice(
              (this.table_marker_domain.currentPage-1)*this.table_marker_domain.pageSize,
              this.table_marker_domain.currentPage*this.table_marker_domain.pageSize)"
          :row-style="{height: '30px'}"
          stripe
          :cell-style="{padding: '0', color: 'black', margin: '0'}">
        <el-table-column prop="gene" label="gene" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.gene"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getGenes">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.gene"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.gene) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="p_val" label="p_val" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.p_val"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getDataset">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.p_val"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.p_val) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="avg_log2FC" label="avg_log2FC" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.avg_log2FC"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getSample">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.avg_log2FC"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.avg_log2FC) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="pct.1" label="pct.1" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.pct_1"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getTechnology">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.pct_1"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.pct_1) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="pct.2" label="pct.2" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.pct_2"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getOrgan">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.pct_2"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.pct_2) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="p_val_adj" label="p_val_adj" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.p_val_adj"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getTissue">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.p_val_adj"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.p_val_adj) }}</div>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="cluster" label="cluster" show-tooltip-when-overflow align="center" sortable>
          <!--          <template slot-scope="scope">-->
          <!--            <div v-if="scope.$index === 0">-->
          <!--              <el-select v-model="this.table_marker_celltype.form.cluster"-->
          <!--                         placeholder="all"-->
          <!--                         clearable-->
          <!--                         filterable-->
          <!--                         multiple-->
          <!--                         @change="getSpots">-->
          <!--                <el-option-->
          <!--                    v-for="item in this.table_marker_celltype.List.cluster"-->
          <!--                    :key="item"-->
          <!--                    :label="item"-->
          <!--                    :value="item">-->
          <!--                </el-option>-->
          <!--              </el-select>-->
          <!--            </div>-->
          <!--            <div v-else>{{ (scope.row.cluster) }}</div>-->
          <!--          </template>-->
        </el-table-column>
      </el-table>
      <el-pagination align='center' @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                     :current-page="this.table_marker_domain.currentPage"
                     :page-sizes="[10,20,50,100]"
                     :page-size="this.table_marker_domain.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="this.table_marker_domain.tableData.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import MyGridLayout from "@/components/tools/MyGridLayout";
export default {
  name: "Dataset_Marker_grid",
  components: {MyGridLayout},
  data(){
    return{
      isGridShow: false,
      layoutData: [
        // { x: 0, y: 0, w: 4, h: 15, i: "0", type: "MarkerCard", data:{datasetID: '', Array: ''} },
      ],
      index: 0,
      position: [],
      gene_list_options: [],
      rangeNumber: 100,
      groundtruth_source: '',
      echart_info: {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      },
      formData: {
        datasetID: '',
        Array:  '',
        Gene: [],
      },
      gene_list: [],
      //table
      table_marker_celltype: {
        tableData: [],
        showData: [],
        form: {
          p_val: '',
          avg_log2FC: '',
          pct_1: '',
          pct_2: '',
          p_val_adj: '',
          cluster: '',
          gene: ''
        },
        List: {
          p_val: [],
          avg_log2FC: [],
          pct_1: [],
          pct_2: [],
          p_val_adj: [],
          cluster: [],
          gene: []
        },
        currentPage: 1, // 当前页码
        total: 100, // 总条数
        pageSize: 20 // 每页的数据条数
      },
      table_marker_domain: {
        tableData: [],
        showData: [],
        form: {
          p_val: '',
          avg_log2FC: '',
          pct_1: '',
          pct_2: '',
          p_val_adj: '',
          cluster: '',
          gene: ''
        },
        List: {
          p_val: [],
          avg_log2FC: [],
          pct_1: [],
          pct_2: [],
          p_val_adj: [],
          cluster: [],
          gene: []
        },
        currentPage: 1, // 当前页码
        total: 100, // 总条数
        pageSize: 20 // 每页的数据条数
      },
    }
  },
  props:{
    asyncData:{
      classification_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      fine_annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      celltype_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      major_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      minor_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      subset_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
    },
    asynGround: String,
    datasetInfo: Array,
    position_main: Array,
  },
  provide() {
    return {
      addNewCardMethod: this.addNewCardHandle,
    };
  },
  mounted() {
    this.echart_info = this.asyncData
    this.position = this.position_main
    this.groundtruth_source= this.asynGround
    this.formData.datasetID = this.datasetInfo[0].datasetID
    this.formData.Array = this.datasetInfo[0].name
    this.$nextTick(function () {
      (async()=>{
        await this.getTablesData()
        this.initLayoutData()
      })();
      // this.initDatasetMarkerGrid()
    })
  },
  directives:{
    'el-select-loadmore':(el, binding) => {
      // console.log(el)
      // console.log(binding)
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
      if(SELECTWRAP_DOM){
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop - 10 <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    },
  },
  methods: {
    getTablesData() {
      let _this = this
      return new Promise((resolve) => {
        _this.$axios.get(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/table/'
            + _this.formData.datasetID + '/' + _this.formData.Array)
            .then(function (response){
              _this.table_marker_celltype.tableData = eval('(' + response.data.celltype + ')')
              _this.table_marker_domain.tableData = eval('(' + response.data.domain + ')')
              let arr1 = _this.table_marker_celltype.tableData.map(v => {return v.gene})
              let arr2 = _this.table_marker_domain.tableData.map(v => {return v.gene})
              _this.gene_list = Array.from(new Set([...arr1, ...arr2]))
              // console.log(_this.gene_list)
              resolve()
            })
      });
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.table_marker_celltype.currentPage = 1;
      this.table_marker_celltype.pageSize = val;
      this.table_marker_celltype.showData = this.table_marker_celltype.tableData.slice(
          (this.table_marker_celltype.currentPage-1)*this.table_marker_celltype.pageSize,
          this.table_marker_celltype.currentPage*this.table_marker_celltype.pageSize)
      this.table_marker_celltype.showData.unshift('{}')
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.table_marker_celltype.currentPage = val;
      this.table_marker_celltype.showData = this.table_marker_celltype.tableData.slice(
          (this.table_marker_celltype.currentPage-1)*this.table_marker_celltype.pageSize,
          this.table_marker_celltype.currentPage*this.table_marker_celltype.pageSize)
      this.table_marker_celltype.showData.unshift('{}')
      // console.log(this.showData)
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange2(val) {
      // console.log(`每页 ${val} 条`);
      this.table_marker_domain.currentPage = 1;
      this.table_marker_domain.pageSize = val;
      this.table_marker_domain.showData = this.table_marker_domain.tableData.slice(
          (this.table_marker_domain.currentPage-1)*this.table_marker_domain.pageSize,
          this.table_marker_domain.currentPage*this.table_marker_domain.pageSize)
      this.table_marker_domain.showData.unshift('{}')
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange2(val) {
      // console.log(`当前页: ${val}`);
      this.table_marker_domain.currentPage = val;
      this.table_marker_domain.showData = this.table_marker_domain.tableData.slice(
          (this.table_marker_domain.currentPage-1)*this.table_marker_domain.pageSize,
          this.table_marker_domain.currentPage*this.table_marker_domain.pageSize)
      this.table_marker_domain.showData.unshift('{}')
      // console.log(this.showData)
    },

    initLayoutData(){
      let index = 0
      let temp_layout = []
      if (this.asynGround !== '' || this.asynGround.length !== 0){
        temp_layout.push({
          x: Math.round((index % 3) * 4),
          y:  Math.round(index / 3),
          w: 4,
          h: 15,
          i: 'marker'+index.toString(),
          type: "TruthImageCard",
          data:{
            datasetID: this.formData.datasetID,
            groundtruth_source: this.asynGround
          }
        },)
        index++
      }
      let item;
      for(item in this.echart_info) {
        if (this.echart_info[item].source.length !== 0){
          let info_pic = ''
          switch (item) {
            case 'classification_info':
              info_pic = 'spatial domain';
              break;
            case 'annot_type_info':
              info_pic = 'anno_true';
              break;
            case 'fine_annot_type_info':
              info_pic = 'fine_anno_true';
              break;
            case 'celltype_info':
              info_pic = 'celltype';
              break;
            case 'major_info':
              info_pic = 'celltype_major';
              break;
            case 'minor_info':
              info_pic = 'celltype_minor';
              break;
            case 'subset_info':
              info_pic = 'celltype_subset';
              break;
          }
          // console.log(item)
          // console.log(this.echart_info[item])
          // console.log(info_pic)
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: 'marker'+index.toString(),
            type: "InfoCard",
            data:{
              info: this.echart_info[item],
              info_type: info_pic
            },
          },)
          index++;
        }
      }
      temp_layout.push({
        x: Math.round((index % 3) * 4),
        y: Math.round(index / 3),
        w: 4,
        h: 15,
        i: 'marker'+index.toString(),
        type: "MarkerCard",
        data:{
          datasetID: this.formData.datasetID,
          array: this.formData.Array,
          position: this.position,
          genes: this.gene_list
        },
      },)
      index++;
      temp_layout.push({
        x: Math.round((index % 3) * 4),
        y: Math.round(index / 3),
        w: 4,
        h: 15,
        i: 'marker'+index.toString(),
        type: "AddNewCard",
      },)
      index++;

      this.layoutData = temp_layout
      console.log(this.layoutData)
      this.index = index
      this.isGridShow = true
    },
    addNewCardHandle() {
      let _index = this.index;
      let temp_json = {
        x: Math.round((_index % 3) * 4),
        y: Math.round(_index / 3),
        w: 4,
        h: 15,
        i: 'marker'+_index.toString(),
        type: "MarkerCard",
        data:{
          datasetID: this.formData.datasetID,
          array: this.formData.Array,
          position: this.position,
          genes: this.gene_list
        },
      };
      _index++;
      this.index = _index
      this.layoutData.splice(_index-2, 0, temp_json)
      console.log(this.layoutData)
    },
  }
}
</script>

<style scoped>

</style>
